import {Fetch} from "./Fetch";

function fetchHelper(url: string, action: (response: any) => void, dispatch: any|undefined): void {
    Fetch.Build(`/${url}`, dispatch).success(action).get();
}

export default fetchHelper;